<div class="insurance-premium-rate-card-component">

  <div class="mat-h3 rate-card-section-title">Base Interest Rate</div>
  <div class="row">
    <div class="col-lg-3 col-md-12">
      <mat-form-field>
        <mat-label>Base interest rate</mat-label>
        <input matInput [inputMask]="createTwoDecimalInputMask" type="text" [formControl]="formControlBaseInterestRate" required>
        <span class="mdi mdi-percent" matSuffix></span>
        @for (errorKey of errorKeys(formControlBaseInterestRate); track errorKey) {
          <mat-error>
            @if (formControlBaseInterestRate.touched && formControlBaseInterestRate.hasError(errorKey)) {
              {{errorMessage(formControlBaseInterestRate, errorKey)}}
            }
          </mat-error>
        }
      </mat-form-field>
    </div>
  </div>
  <mat-divider class="separator-bottom" [inset]="true"></mat-divider>

  <min-max-rate formControlErrorsIgnore title="Loan amount" [formControl]="formControlLoanAmount"></min-max-rate>
  <mat-divider class="separator-bottom" [inset]="true"></mat-divider>

  <min-max-rate formControlErrorsIgnore title="Loan terms" [formControl]="formControlLoanTerms"></min-max-rate>
  <mat-divider class="separator-bottom" [inset]="true"></mat-divider>

  <div class="mat-h3 rate-card-section-title">Risk Profile</div>
  <div class="row">
    <div class="col-lg-3 col-md-12">
      <mat-form-field>
        <mat-label>Adverse on file</mat-label>
        <input matInput [inputMask]="createTwoDecimalInputMask" type="text" [formControl]="formControlAdverseOnFile" required>
        <span class="mdi mdi-percent" matSuffix></span>
        @for (errorKey of errorKeys(formControlAdverseOnFile); track errorKey) {
          <mat-error>
            @if (formControlAdverseOnFile.touched && formControlAdverseOnFile.hasError(errorKey)) {
              {{errorMessage(formControlAdverseOnFile, errorKey)}}
            }
          </mat-error>
        }
      </mat-form-field>
    </div>
    <div class="col-lg-3 col-md-12">
      <mat-form-field>
        <mat-label>Low director-score (&lt; 550) uplift</mat-label>
        <input [inputMask]="createTwoDecimalInputMask" matInput type="text" [formControl]="formControlLowDirectorScoreUplift" required>
        <span class="mdi mdi-percent" matSuffix></span>
        @for (errorKey of errorKeys(formControlLowDirectorScoreUplift); track errorKey) {
          <mat-error>
            @if (formControlLowDirectorScoreUplift.touched && formControlLowDirectorScoreUplift.hasError(errorKey)) {
              {{errorMessage(formControlLowDirectorScoreUplift, errorKey)}}
            }
          </mat-error>
        }
      </mat-form-field>
    </div>
  </div>
  <mat-divider class="separator-bottom" [inset]="true"></mat-divider>

  <min-max-rate title="Doc Fee" [type]="'currency'" [formControl]="formControlDocFee"></min-max-rate>

</div>
